import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import Logo from "../assets/images/PAYLOFT_LOGO.png";
import DashboardImage from "../assets/images/dashboard.png";
import UsersImage from "../assets/images/users.png";
import ReportsImage from "../assets/images/transactions.png";
// import NotificationsImage from "../assets/images/notification.png";
// import Migrate from "../assets/images/migrate.png";
// import DisputeActive from "../assets/images/dispute-active.png";
import PaymentsImage from "../assets/images/payments.png";
import SettingsImage from "../assets/images/setting.png";
import DashboardActive from "../assets/images/dashboard-active.png";
import UsersActive from "../assets/images/users-active.png";
import TransferActive from "../assets/images/transfer.png";
import { useAuth } from "../context/AuthContextProvider";
import { FaRecycle } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import { MdCreateNewFolder } from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { IoSettings } from "react-icons/io5";
import { LiaBullseyeSolid } from "react-icons/lia";
import { LuUsers } from "react-icons/lu";
import { CgOrganisation } from "react-icons/cg";
import { DiGitPullRequest } from "react-icons/di";
const permissionMapping = {
  "/dashboard": ["View Dashboard"],
  "/reports": ["List Transactions", "View Audit Trails"],
  "/reports/audits": ["View Audit Trails"],
  "/merchants": ["Get Credentials", "Add Settlement Account", "Create Payment Link"],
  "/users": ["List Users", "Create User", "Update User", "Disable User", "Enable User", "Invite New Member", "List Roles", "Create Role", "Get Permission List"],
  "/create-client": ["Create User", "Create Role"],
  "/client-transactions": ["List Transactions"],
  "/organisation": ["List Roles", "Get Permission List", "List Users"],
  "/roles-permissions": ["List Roles", "Create Role", "Get Permission List"],
  "/domain-requests": ["List Roles", "Get Permission List"],
  "/split-payment": ["List Transactions"],
  "/refund-requests": ["List Transactions"],
  "/subscriptions": ["List Transactions", "View Dashboard"],
  "/inactive-requests": ["List Transactions", "View Audit Trails"],
  "/prospects": ["List Users", "View Dashboard"],
  "/level-four-prospects": ["List Users", "View Dashboard"],
  "/config-requests": ["List Roles", "Get Permission List"],
  "/edit-merchant-requests": ["Get Credentials", "Add Settlement Account"],
  /*   "/approve-msc": [], */
  "/settings": [] // Always visible
};

const Sidebar = () => {
  const location = useLocation();
  const { userrole, user } = useAuth();
  const permissions = user?.permissionList || [];
  const inactiveClass =
    "flex items-center py-4 px-5 gap-3 text-gray-400 hover:bg-gray-100 rounded-md transition-colors";
  const activeClass =
    "flex items-center py-4 px-5 gap-3 text-primary  rounded-md";

  const role = userrole?.role;

  const isBusinessMaker =
    role === "Business Support Maker" || role === "Operation Officer";

  const isRiskUser = role === "Risk User" || role === "Compliance Officer";

  const isBusinessSupport = role === "Business Support" || role === "Viewer";

  const isBusinessChecker = role === "Business Support Checker";

  const isAdmin = role === "Admin";



  const getLinks = () => {
    const commonLinks = [
      {
        to: "/dashboard",
        text: "Dashboard",
        imageSource: DashboardImage,
        alternateImage: DashboardActive,
        icons: <MdDashboard />,
      },
      {
        to: "/reports",
        text: "Reports",
        imageSource: ReportsImage,
        icons: <TbReport />,
      },
      {
        to: "/merchants",
        text: "Merchants",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <LiaBullseyeSolid />,
      },
      {
        to: "/users",
        text: "Users",
        imageSource: UsersImage,
        alternateImage: UsersActive,
        icons: <LuUsers />,
      },
      {
        to: "/create-client",
        text: "Create Client",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <MdCreateNewFolder />,
      },
      {
        to: "/client-transactions",
        text: "Client Transaction",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <GrTransaction />,
      },
      {
        to: "/organisation",
        text: "Organisation",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <CgOrganisation />,
      },
      {
        to: "/roles-permissions",
        text: "Roles & Permissions",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <LuUsers />,
      },
      {
        to: "/approve-msc",
        text: "Approve MSC",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <DiGitPullRequest />,
      },
      {
        to: "/split-payment",
        text: "Split Payment",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <GrTransaction />,
      },
      {
        to: "/refund-requests",
        text: "Refund Requests",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <DiGitPullRequest />,
      },
      {
        to: "/subscriptions",
        text: "Subscriptions",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <LuUsers />,
      },
      {
        to: "/inactive-requests",
        text: "Inactive Requests",
        imageSource: PaymentsImage,
        alternateImage: TransferActive,
        icons: <DiGitPullRequest />,
      },
      {
        to: "/settings",
        text: "Settings",
        imageSource: SettingsImage,
        icons: <IoSettings />,
      },
    ];

    if (isBusinessMaker) {
      return [
        {
          to: "/dashboard",
          text: "Dashboard",
          imageSource: DashboardImage,
          alternateImage: DashboardActive,
          icons: <MdDashboard />,
        },
        {
          to: "/reports",
          text: "Reports",
          imageSource: ReportsImage,
          icons: <TbReport />,
        },
        {
          to: "/merchants",
          text: "Merchants",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <LiaBullseyeSolid />,
        },
        {
          to: "/prospects",
          text: "Prospects",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/client-transactions",
          text: "Client Transaction",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <GrTransaction />,
        },
        {
          to: "/organisation",
          text: "Organisation",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <CgOrganisation />,
        },
        {
          to: "/approve-msc",
          text: "Approve MSC",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <DiGitPullRequest />,
        },
        {
          to: "/settings",
          text: "Settings",
          imageSource: SettingsImage,
          icons: <IoSettings />,
        },
      ];
    }

    if (isRiskUser) {
      return [
        {
          to: "/dashboard",
          text: "Dashboard",
          imageSource: DashboardImage,
          alternateImage: DashboardActive,
          icons: <MdDashboard />,
        },
        {
          to: "/reports/audits",
          text: "Reports",
          imageSource: ReportsImage,
          icons: <TbReport />,
        },
        {
          to: "/merchants",
          text: "Merchants",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <LiaBullseyeSolid />,
        },
        {
          to: "/prospects",
          text: "Prospects",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/users",
          text: "Users",
          imageSource: UsersImage,
          alternateImage: UsersActive,
          icons: <LuUsers />,
        },
        {
          to: "/settings",
          text: "Settings",
          imageSource: SettingsImage,
          icons: <IoSettings />,
        },
      ];
    }

    if (isBusinessChecker) {
      return [
        {
          to: "/dashboard",
          text: "Dashboard",
          imageSource: DashboardImage,
          alternateImage: DashboardActive,
          icons: <MdDashboard />,
        },
        {
          to: "/merchants",
          text: "Merchants",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <LiaBullseyeSolid />,
        },
        {
          to: "/reports",
          text: "Reports",
          imageSource: ReportsImage,
          icons: <TbReport />,
        },
        {
          to: "/prospects",
          text: "Prospects",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/level-four-prospects",
          text: "Level 4 Prospects",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/config-requests",
          text: "Config Requests",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/client-transactions",
          text: "Client Transaction",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <GrTransaction />,
        },
        {
          to: "/edit-merchant-requests",
          text: "Merchant Requests",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <FaRecycle />,
        },
        {
          to: "/split-payment",
          text: "Split Payment",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <GrTransaction />,
        },
        {
          to: "/organisation",
          text: "Organisation",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <CgOrganisation />,
        },
        {
          to: "/roles-permissions",
          text: "Roles & Permissions",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <LuUsers />,
        },
        {
          to: "/approve-msc",
          text: "Approve MSC",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <DiGitPullRequest />,
        },
        {
          to: "/domain-requests",
          text: "Organisation Requests",
          imageSource: PaymentsImage,
          alternateImage: TransferActive,
          icons: <DiGitPullRequest />,
        },

        {
          to: "/settings",
          text: "Settings",
          imageSource: SettingsImage,
          icons: <IoSettings />,
        },
      ];
    }

    if (isBusinessSupport) {
      return [
        // {
        //   to: "/merchants",
        //   text: "Merchants",
        //   imageSource: PaymentsImage,
        //   alternateImage: TransferActive,
        //   icons: <LiaBullseyeSolid />,
        // },
        {
          to: "/dashboard",
          text: "Dashboard",
          imageSource: DashboardImage,
          alternateImage: DashboardActive,
          icons: <MdDashboard />,
        },
        {
          to: "/reports",
          text: "Reports",
          imageSource: ReportsImage,
          icons: <TbReport />,
        },
        // {
        //   to: "/client-transactions",
        //   text: "Client Transaction",
        //   imageSource: PaymentsImage,
        //   alternateImage: TransferActive,
        //   icons: <GrTransaction />,
        // },
        {
          to: "/settings",
          text: "Settings",
          imageSource: SettingsImage,
          icons: <IoSettings />,
        },
      ];
    }

    if (isAdmin) {
      return [
        {
          to: "/dashboard",
          text: "Dashboard",
          icons: <MdDashboard />,
        },
        {
          to: "/merchants",
          text: "Merchants",
          icons: <LiaBullseyeSolid />,
        },
        {
          to: "/reports",
          text: "Reports",
          icons: <TbReport />,
        },
        {
          to: "/prospects",
          text: "Prospects",
          icons: <FaRecycle />,
        },
        {
          to: "/level-four-prospects",
          text: "Level 4 Prospects",
          icons: <FaRecycle />,
        },
        {
          to: "/config-requests",
          text: "Config Requests",
          icons: <FaRecycle />,
        },
        {
          to: "/client-transactions",
          text: "Client Transaction",
          icons: <GrTransaction />,
        },
        {
          to: "/edit-merchant-requests",
          text: "Merchant Requests",
          icons: <FaRecycle />,
        },
        {
          to: "/split-payment",
          text: "Split Payment",
          icons: <GrTransaction />,
        },
        {
          to: "/roles-permissions",
          text: "Roles & Permissions",
          icons: <LuUsers />,
        },
        {
          to: "/approve-msc",
          text: "Approve MSC",
          icons: <DiGitPullRequest />,
        },
        {
          to: "/settings",
          text: "Settings",
          icons: <IoSettings />,
        },
      ];
    }

    return commonLinks;
  };

  const links = getLinks().filter(link => {
    if (isAdmin) return true;

    const requiredPerms = permissionMapping[link.to];
    if (!requiredPerms || requiredPerms.length === 0) return true;

    return requiredPerms.some(perm =>
      permissions.some(userPerm => userPerm.toLowerCase() === perm.toLowerCase())
    );
  });

  return (
    <div className="bg-arena-background h-full">
      <div className="flex">
        <div className="bg-white pt-4 w-[218px] xl:w-[13%] h-[1047px] flex flex-col justify-between">
          <div className="flex flex-col items-center">
            <img
              src={window.__TENANT__?.logo ?? Logo}
              alt="logo"
              className="w-[150px] h-auto"
            />
            <div className="w-[191.98px] ">
              {links.map((link, index) => (
                <NavLink
                  key={index}
                  to={link.to}
                  style={{ backgroundSize: "25%" }}
                  className={
                    location.pathname === link.to ||
                      location.pathname.startsWith(`${link.to}`)
                      ? `${activeClass} active-gradient`
                      : inactiveClass
                  }
                >
                  {/* <img
                    src={
                      location.pathname === link.to ||
                      location.pathname.startsWith(`${link.to}`)
                        ? link.alternateImage
                        : link.imageSource
                    }
                    alt={link.text.toLowerCase()}
                    className="w-6 h-6"
                  /> */}
                  <p className="text-2xl">{link.icons}</p>
                  <p className="text-base font-semibold">{link.text}</p>
                </NavLink>
              ))}
              {/* <div className="border-t pt-6">
                <NavLink className="flex py-3 px-5 gap-3">
                  <img src={Migrate} alt="migrate" className="w-6 h-6" />
                  <p className="text-gray-400 text-base font-bold">
                    Migrate to Production
                  </p>
                </NavLink>
              </div> */}
            </div>
          </div>
          {/* <div>
            <ProfileNav />
          </div> */}
        </div>
        <div className="w-full px-6 xl:w-[87%]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
